import { graphql } from "@/gql";

export const USER_QUERY = graphql(`
  query USER_QUERY($id: String!) {
    adminUser(id: $id) {
      id
      avatarUrl
      fullName
      applicationRole
      createdAt
      lastActiveAt
      isEnabled
      phoneNumber
      emailAddress
      primaryAuth0Id
      phoneNumberAuth0Id
      emailAddressAuth0Id
      pendingEmailAddress
      pendingPhoneNumber
      memberships {
        edges {
          node {
            id
            isEnabled
            organizationRole
            organization {
              id
              name
            }
          }
        }
      }
      mobileDevices {
        edges {
          node {
            id
            deviceType
            deviceModel
            deviceOsVersion
            applicationVersion
            isSandbox
            operationalStatus
          }
        }
      }
    }
  }
`);
